import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { WorkSchedule } from '@app/models/time-off-v3/works-schedule.model';
import { AnalyticService, NotifyService } from '@app/services';
import { Location } from '@angular/common';
import { AnalyticEvents } from '@app/enums';

@Component({
    templateUrl: './work-schedules-overall-settings-update.template.html',
    styleUrls: ['./work-schedules-overall-settings-update.style.scss'],
})
export class WorkScheduleOverallSettingsUpdateView {
    workSchedule: WorkSchedule = new WorkSchedule();
    isLoading = false;

    constructor(
        private analyticService: AnalyticService,
        private notify: NotifyService,
        private router: Router,
        private route: ActivatedRoute,
        private location: Location
    ) {
        this.workSchedule = this.route.snapshot.data.models.get('work-schedule');
    }

    onCancel(): void {
        this.location.back();
    }

    async onSave(): Promise<void> {
        this.isLoading = true;

        try {
            await this.workSchedule.save();

            this.analyticService.trackEvent(AnalyticEvents.TimeOffSettingsEditOrCreateWorkSchedule);
            this.notify.success('time-off-v3.update.savedSuccessfully');
            this.router.navigate(['/', 'time-off', 'v3', 'work-schedule', this.workSchedule.id, 'details']);
        } catch (error) {
            this.notify.error(error);
        } finally {
            this.isLoading = false;
        }
    }
}
